import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLine} from "@fortawesome/free-brands-svg-icons";
import SubHeader from "../../components/SubHeader/SubHeader";
import {Helmet} from "react-helmet-async";

const breadcrumbs = [
    {label: "ホーム", link: "/"},
    {label: "お問い合わせと会社情報"},
];

const Contact = () => {
    return (
        <>
            <Helmet>
                <title>お問い合わせと会社情報</title>
            </Helmet>

            <div className=" ">
            <div className="row ">
                <div className="col-12">
                {/*<SubHeader*/}
                {/*    title="お問い合わせと会社情報"*/}
                {/*    breadcrumbs={breadcrumbs}*/}
                {/*/>*/}
                </div>
            </div>
                <div className="row g-4 mt-2">

                    {/* ================= CONTACT ================= */}
                    <div className="col-12 col-lg-6">

                        <div className="card shadow-sm border-0 h-100">
                            <div className="card-body">

                                <h4 className="fw-bold">お問い合わせ</h4>
                                <p className="text-muted">
                                    2営業日以内にお返事いたします！
                                </p>

                                <a
                                    href="https://line.me/R/ti/p/%40dii1064j"
                                    className="btn btn-success w-100 mb-3 d-flex align-items-center justify-content-center gap-2"
                                >
                                    <FontAwesomeIcon icon={faLine}/>
                                    LINEで相談する
                                </a>

                                {/*/!* Form placeholder *!/*/}
                                {/*<div className="border rounded p-3 bg-light text-center">*/}
                                {/*  <small className="text-muted">*/}
                                {/*    お問い合わせフォームがここに表示されます*/}
                                {/*  </small>*/}
                                {/*</div>*/}

                            </div>
                        </div>

                    </div>

                    {/* ================= COMPANY ================= */}
                    <div className="col-12 col-lg-6">

                        <div className="card shadow-sm border-0 h-100">
                            <div className="card-body">

                                <h4 className="fw-bold">会社情報</h4>
                                <p className="text-muted mb-3">
                                    ジェイさんツアーの運営会社情報です
                                </p>

                                <div className="table-responsive">
                                    <table className="table table-sm align-middle">
                                        <tbody>
                                        <tr>
                                            <th>会社名</th>
                                            <td>JAY&JAY Pty Ltd</td>
                                        </tr>
                                        <tr>
                                            <th>設立</th>
                                            <td>1996年8月13日</td>
                                        </tr>
                                        <tr>
                                            <th>代表</th>
                                            <td>JAY SAMARAKOON</td>
                                        </tr>
                                        <tr>
                                            <th>所在地</th>
                                            <td>78 Scott St, QLD Australia</td>
                                        </tr>
                                        <tr>
                                            <th>電話</th>
                                            <td>
                                                +61 7 4041-2583 <br/>
                                                1800-444-154
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>事業</th>
                                            <td>ツアー催行・予約手配</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>

                    </div>

                    {/* ================= MAP ================= */}
                    <div className="col-12">

                        <div className="card shadow-sm border-0">
                            <div className="card-body p-0">

                                <div className="ratio ratio-16x9">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15268.013574369199!2d145.75935115399506!3d-16.92512481449215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x697867043f6b4ee5%3A0x4e7f5549287b9505!2z44Kx44Ki44Oz44K644OE44Ki44O844O75peF6KGM44O76Kaz5YWJ44Gv44CQ44K444Kn44Kk44GV44KT44OE44Ki44O844CR!5e0!3m2!1sja!2sjp!4v1558338060182!5m2!1sja!2sjp"
                                        width="100%"
                                        height="600"
                                        frameBorder="0"
                                        style={{border: '0', pointerEvents: 'none'}}
                                        allowFullScreen=""
                                    />
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    );
};

export default Contact;